import React from "react";

function SaveIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8249 0.640625C12.3085 0.647513 12.7698 0.845199 13.1083 1.19062L16.5916 4.67396C16.937 5.01245 17.1347 5.47371 17.1416 5.95729V15.3073C17.1416 15.7935 16.9484 16.2598 16.6046 16.6037C16.2608 16.9475 15.7945 17.1406 15.3083 17.1406H2.47493C1.9887 17.1406 1.52239 16.9475 1.17857 16.6037C0.834756 16.2598 0.641602 15.7935 0.641602 15.3073V2.47396C0.641602 1.98773 0.834756 1.52141 1.17857 1.1776C1.52239 0.833779 1.9887 0.640625 2.47493 0.640625H11.8249Z"
        stroke="white"
        strokeWidth="1.28333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.475 17.1406V10.724C13.475 10.4808 13.3784 10.2477 13.2065 10.0758C13.0346 9.90387 12.8015 9.80729 12.5583 9.80729H5.22502C4.9819 9.80729 4.74874 9.90387 4.57684 10.0758C4.40493 10.2477 4.30835 10.4808 4.30835 10.724V17.1406M4.30835 0.640625V4.30729C4.30835 4.55041 4.40493 4.78356 4.57684 4.95547C4.74874 5.12738 4.9819 5.22396 5.22502 5.22396H11.6417"
        stroke="white"
        strokeWidth="1.28333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SaveIcon;
